<template>
  <Flex
    align="center"
    :gap=".5"
  >
    <div
      :style="{ backgroundColor: color }"
      :class="$style.square"
    ></div>
    <BaseHeading size="s">{{ text }}</BaseHeading>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  text: string;
  color: string;
}>();
</script>

<style
  lang="scss"
  module
>
.square {
  width: 8px;
  height: 8px;
}
</style>
